module.exports = __webpack_public_path__ + "media/banners/agentbox-2-f2479327.png";